<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}检测项目`"
    width="1100px"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="检测项目" prop="remark">
            <el-input v-model.trim="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模版编号" prop="sampleCode">
            <el-input v-model.trim="editForm.sampleCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="报告名称" prop="sampleBelong">
            <el-input v-model.trim="editForm.sampleBelong" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测依据">
            <el-table border :data="basisList" height="300" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column prop="basisName" label="依据的标准名称及编号（含年号）" header-align="center"></el-table-column>
              <el-table-column align="center" width="120">
                <template slot="header">
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleBasisAdd"></el-button>
                </template>
                <template v-slot="{ row, $index }">
                  <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="handleDelBasis($index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测设备">
            <el-table border :data="deviceList" height="300" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="nxCheckTime" label="有效日期" align="center"></el-table-column>
              <el-table-column align="center" width="80">
                <template slot="header">
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleDeviceAdd"></el-button>
                </template>
                <template v-slot="{ row, $index }">
                  <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="handleDeviceDel($index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>

    <!-- 检测依据选择弹窗 -->
    <BasisSelect
      :visible.sync="basisVisible"
      :selectTitle="`检测项目：${editForm.remark || ''}`"
      :checkedList="basisList"
      @setBasisList="setBasisList"
    />
    <!-- 设备选择 -->
    <DeviceSelect
      :visible.sync="deviceVisible"
      :selectTitle="`检测项目：${editForm.remark || ''}`"
      :checkedList="deviceList"
      @setDevList="setDevList"
    />
  </drag-dialog>
</template>

<script>
import BasisSelect from '@/views/system/testBasis/components/BasisSelect';
import DeviceSelect from '@/views/device/components/DeviceSelect';

import { getSample, editSample, getItem, editItem } from '@/api/system';

export default {
  components: { BasisSelect, DeviceSelect },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {},
      itemList: [],
      basisList: [],
      deviceList: [],
      rules: {
        remark: [{ required: true, message: '请输入检测项目', trigger: 'blur' }],
        sampleCode: [{ required: true, message: '请输入模版编码', trigger: 'blur' }],
        sampleBelong: [{ required: true, message: '请输入报告名称', trigger: 'blur' }]
      },
      basisVisible: false,
      deviceVisible: false,
      activeBasisId: null
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getSample({ id: this.activeId });

        this.editForm = {
          id: data.id,
          sampleCode: data.sampleCode,
          unitPrice: data.unitPrice,
          checkPeriod: data.checkPeriod,
          oriVersion: data.oriVersion,
          etmtType: data.etmtType,
          sampleType: data.sampleType,
          type: data.type,
          sampleBelong: data.sampleBelong,
          cate: data.cate,
          remark: data.remark
        };
        this.itemList = data.itemList ?? [];
        this.deviceList = data.deviceList ?? [];
        this.getBasisList();
      } finally {
        this.detailLoading = false;
      }
    },
    // 获取检测项目下检测依据列表
    async getBasisList() {
      const promises = this.itemList.map(async item => {
        const { data } = await getItem({ id: item.itemId });
        return data.basisList ?? [];
      });

      const returnAll = await Promise.all(promises);
      let basisList = [];
      returnAll.map(item => basisList.push(...item));
      this.basisList = basisList.sort((a, b) => a.remark - b.remark);
    },
    setBasisList(val) {
      this.basisList = val;
    },
    // 添加检测依据
    handleBasisAdd() {
      this.basisVisible = true;
    },
    async handleDelBasis(index) {
      this.basisList.splice(index, 1);
    },
    // 检测设备
    handleDeviceAdd() {
      this.deviceVisible = true;
    },
    handleDeviceDel(index) {
      this.deviceList.splice(index, 1);
    },
    setDevList(val) {
      this.deviceList = val;
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          let itemList = [];

          if (this.itemList.length > 0) {
            // 编辑检测项目
            const itemId = this.itemList[0].itemId;
            await editItem({
              id: itemId,
              itemName: this.editForm.remark,
              itemCode: this.editForm.sampleCode + '01',
              basisList: this.basisList
            });
            itemList = this.itemList.map(item => {
              return {
                itemId: item.itemId
              };
            });
          } else {
            const { data } = await editItem({
              itemName: this.editForm.remark,
              itemCode: this.editForm.sampleCode + '01',
              basisList: this.basisList
            });
            itemList = [
              {
                itemId: data
              }
            ];
          }

          const deviceList = this.deviceList.map(item => {
            return {
              devId: item.devId
            };
          });
          const params = { ...this.editForm, sampleName: this.editForm.remark, itemList, deviceList };
          try {
            await editSample(params);
            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
